import { useStaticQuery, graphql } from "gatsby";
import NewLatestArticles from "../NewLatestArticles";
import React from "react";

export function StaticArticlesGrid({ entry }) {
  const { latestBlogs } = useStaticQuery(graphql`
    query HeaderQuery {
      latestBlogs: allContentfulArticle(
        limit: 10
        sort: { fields: publishDate, order: DESC }
        filter: {
          heroImage: { id: { ne: null } }
          type: { ne: null }
          title: { ne: null }
          slug: { ne: null }
        }
      ) {
        edges {
          node {
            ...ArticleWithImage
          }
        }
      }
    }
  `);

  const extra = {
    articlesList: latestBlogs?.edges.map(({ node }) => node),
  };


  return <NewLatestArticles extra={extra} entry={entry} />;
}
